import styled from 'styled-components';

export default styled.p`
  color:${({ theme }) => theme.palette.grey[1]};
  font-weight: 400;
  margin: 0;
  font-size: 1.2rem;
`;
